/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A line item is rejected only when **both** length and width exceed their trigger values, i.e.
 * the freight does not fit on standard trailers.
 * 
 * @export
 * @interface ShipmentLimitsFlatbed
 */
export interface ShipmentLimitsFlatbed {
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsFlatbed
     */
    lengthTriggerInches: number;
    /**
     * 
     * @type {number}
     * @memberof ShipmentLimitsFlatbed
     */
    widthTriggerInches: number;
}

/**
 * Check if a given object implements the ShipmentLimitsFlatbed interface.
 */
export function instanceOfShipmentLimitsFlatbed(value: object): value is ShipmentLimitsFlatbed {
    if (!('lengthTriggerInches' in value) || value['lengthTriggerInches'] === undefined) return false;
    if (!('widthTriggerInches' in value) || value['widthTriggerInches'] === undefined) return false;
    return true;
}

export function ShipmentLimitsFlatbedFromJSON(json: any): ShipmentLimitsFlatbed {
    return ShipmentLimitsFlatbedFromJSONTyped(json, false);
}

export function ShipmentLimitsFlatbedFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipmentLimitsFlatbed {
    if (json == null) {
        return json;
    }
    return {
        
        'lengthTriggerInches': json['lengthTriggerInches'],
        'widthTriggerInches': json['widthTriggerInches'],
    };
}

  export function ShipmentLimitsFlatbedToJSON(json: any): ShipmentLimitsFlatbed {
      return ShipmentLimitsFlatbedToJSONTyped(json, false);
  }

  export function ShipmentLimitsFlatbedToJSONTyped(value?: ShipmentLimitsFlatbed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lengthTriggerInches': value['lengthTriggerInches'],
        'widthTriggerInches': value['widthTriggerInches'],
    };
}

